export * from './lib/proposal-offline-products.component';
